(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["taffstyle-all-master"] && !Shopify.designMode) return;
  try {
    (() => {
function initTaffstyleAll() {
  document.querySelectorAll('[data-tf-all-guide]').forEach(root => {
    if (root.dataset.tfAllReady) return;
    root.dataset.tfAllReady = 'true';
    const disclosures = Array.from(root.querySelectorAll('.dp-topic-more'));
    let previousMode;
    const sync = () => {
      const mobile = window.matchMedia('(max-width: 650px)').matches;
      if (mobile === previousMode) return;
      previousMode = mobile;
      root.classList.toggle('dp-desktop', !mobile);
      disclosures.forEach(details => { details.open = !mobile; });
    };
    sync();
    window.addEventListener('resize',sync);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initTaffstyleAll);
else initTaffstyleAll();
document.addEventListener('shopify:section:load',initTaffstyleAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-augenbrauen-master-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>{document.querySelectorAll('[data-tf-augenbrauen-master-guide]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('details').forEach(d=>d.open=false)})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();document.addEventListener('shopify:section:load',initialize)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-bauchnabel-master-guide"] && !Shopify.designMode) return;
  try {
    window.addEventListener('pageshow', () => {
  document.querySelectorAll('#root .tf-bauchnabel-master-guide details[open]').forEach(panel => { panel.open = false; });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-bridge-master-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>{document.querySelectorAll('[data-tf-bridge-master-guide]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('details').forEach(d=>d.open=false)})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();document.addEventListener('shopify:section:load',initialize)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-brust-master-guide"] && !Shopify.designMode) return;
  try {
    window.addEventListener('pageshow', () => {
  document.querySelectorAll('#root .tf-brust-master-guide details[open]').forEach(panel => { panel.open = false; });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-category-closing"] && !Shopify.designMode) return;
  try {
    window.addEventListener('pageshow', () => {
  document.querySelectorAll('.tf-category-closing .tfcc-panel[open]').forEach(panel => {
    panel.open = false;
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-charms-master-guide"] && !Shopify.designMode) return;
  try {
    window.addEventListener('pageshow', () => {
  document.querySelectorAll('#root .tf-charms-master-guide details[open]').forEach(panel => { panel.open = false; });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-christina-master-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>{document.querySelectorAll('[data-tf-christina-master-guide]').forEach(root=>{if(root.dataset.faqPackage4Ready)return;root.dataset.faqPackage4Ready='true';root.querySelectorAll('details').forEach(d=>d.open=false)})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();document.addEventListener('shopify:section:load',initialize);window.addEventListener('pageshow',()=>document.querySelectorAll('[data-tf-christina-master-guide] details').forEach(d=>d.open=false))})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-collection-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('taffstyle-collection-reviews')) {
  customElements.define('taffstyle-collection-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.initialized = true;
      const config = JSON.parse(this.querySelector('[data-ts-review-config]').textContent);
      this.labels = config.labels;
      this.fallback = config.reviews;
      this.pageSize = 5;
      this.page = 1;
      this.order = 'date-desc';
      this.source = 'fallback';
      this.total = this.fallback.length;
      this.busy = false;
      this.cache = new Map();
      this.trigger = this.querySelector('.ts-category-reviews__open');
      this.list = this.querySelector('.ts-category-reviews__list');
      this.body = this.querySelector('.ts-category-reviews__body');
      this.previous = this.querySelector('.ts-category-reviews__previous');
      this.next = this.querySelector('.ts-category-reviews__next');
      this.sort = this.querySelector('.ts-category-reviews__sort');
      this.notice = this.querySelector('.ts-category-reviews__notice');
      this.retry = this.querySelector('.ts-category-reviews__retry');
      this.trigger.hidden = false;
      this.trigger.addEventListener('click', () => this.open());
      this.querySelector('.ts-category-reviews__close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => this.restoreScroll());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.previous.addEventListener('click', () => this.loadPage(this.page - 1, this.order, true));
      this.next.addEventListener('click', () => this.loadPage(this.page + 1, this.order, true));
      this.sort.addEventListener('change', () => this.loadPage(1, this.sort.value, true));
      this.retry.addEventListener('click', () => this.loadPage(this.failedPage || 1, this.failedOrder || this.order, true, true));
      this.renderFallback(1, this.order);
      this.resizeObserver = new ResizeObserver(() => this.updateExpansion());
      this.resizeObserver.observe(this.list);
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restoreScroll();
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
    text(key, values = {}) {
      return Object.entries(values).reduce((text, [name, value]) => text.replaceAll('[' + name + ']', String(value)), this.labels[key] || '');
    }
    open() {
      if (this.dialog.open) return;
      this.savedScroll = {x:window.scrollX, y:window.scrollY};
      this.savedBody = {};
      for (const name of ['position','top','left','width','overflow','padding-right']) this.savedBody[name] = {value:document.body.style.getPropertyValue(name), priority:document.body.style.getPropertyPriority(name)};
      const gap = window.innerWidth - document.documentElement.clientWidth;
      const padding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
      Object.assign(document.body.style, {position:'fixed',top:-this.savedScroll.y+'px',left:-this.savedScroll.x+'px',width:'100%',overflow:'hidden',paddingRight:padding+gap+'px'});
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => this.updateExpansion());
      if (this.dataset.storeId && (!this.lastLoaded || Date.now() - this.lastLoaded > 60000)) {
        this.cache.clear();
        this.loadPage(1, this.order, false, true);
      }
    }
    restoreScroll() {
      if (!this.savedScroll) return;
      for (const [name, saved] of Object.entries(this.savedBody)) {
        if (saved.value) document.body.style.setProperty(name, saved.value, saved.priority);
        else document.body.style.removeProperty(name);
      }
      const {x,y} = this.savedScroll;
      this.savedScroll = null;
      window.scrollTo({left:x,top:y,behavior:'instant'});
      this.trigger?.setAttribute('aria-expanded', 'false');
      if (this.isConnected) this.trigger?.focus({preventScroll:true});
    }
    renderFallback(page, order) {
      const [sort, direction] = order.split('-');
      const sorted = [...this.fallback].sort((a,b) => {
        const delta = sort === 'rating' ? Number(a.rating)-Number(b.rating) : new Date(a.date)-new Date(b.date);
        return (direction === 'asc' ? delta : -delta) || new Date(b.date)-new Date(a.date) || String(a.id).localeCompare(String(b.id));
      });
      this.source = 'fallback';
      this.page = page;
      this.order = order;
      this.total = sorted.length;
      this.render(sorted.slice((page-1)*this.pageSize,page*this.pageSize));
    }
    async loadPage(page, order, moveFocus = false, forceApi = false) {
      if (this.busy || page < 1) return;
      if (!this.dataset.storeId || (this.source === 'fallback' && !forceApi)) {
        this.renderFallback(page, order);
        this.finishNavigation(moveFocus);
        return;
      }
      this.busy = true;
      this.setNotice('loading', false);
      this.updateControls();
      this.list.setAttribute('aria-busy','true');
      this.controller = new AbortController();
      const timer = setTimeout(() => this.controller.abort(), 10000);
      try {
        const key = order + ':' + page;
        let result = this.cache.get(key);
        if (!result || Date.now() - result.savedAt > 60000) {
          const [sort,direction] = order.split('-');
          const url = new URL('https://storefront-api.loox.io/storefront/v1/store/' + encodeURIComponent(this.dataset.storeId) + '/product-reviews');
          url.search = new URLSearchParams({page:String(page),limit:String(this.pageSize),sort,direction}).toString();
          const response = await fetch(url, {signal:this.controller.signal,credentials:'omit',headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('Loox status ' + response.status);
          const data = await response.json();
          if (!Array.isArray(data.reviews) || !Number.isInteger(data.pagination?.total) || data.pagination.total < 0 || data.pagination.page !== page) throw new Error('Invalid Loox response');
          result = {...data, savedAt:Date.now()};
          this.cache.set(key,result);
          if (this.cache.size > 12) this.cache.delete(this.cache.keys().next().value);
        }
        if (!this.isConnected) return;
        this.source = 'api';
        this.page = page;
        this.order = order;
        this.total = result.pagination.total;
        this.lastLoaded = Date.now();
        this.setNotice(null, false);
        this.render(result.reviews.slice(0,this.pageSize));
        this.finishNavigation(moveFocus);
      } catch (error) {
        if (!this.isConnected) return;
        this.failedPage = page;
        this.failedOrder = order;
        this.sort.value = this.order;
        this.setNotice('unavailable', true);
      } finally {
        clearTimeout(timer);
        this.busy = false;
        this.list.setAttribute('aria-busy','false');
        this.updateControls();
      }
    }
    setNotice(key, retry) {
      this.notice.hidden = !key;
      this.notice.querySelector('p').textContent = key ? this.text(key) : '';
      this.retry.hidden = !retry;
    }
    render(reviews) {
      this.list.replaceChildren();
      for (const [index, review] of reviews.entries()) {
        const name = review.reviewer?.name || this.text('anonymous');
        const rating = Math.max(0, Math.min(5, Number(review.rating) || 0));
        const article = document.createElement('article');
        article.className = 'ts-category-reviews__item';
        article.setAttribute('aria-label',this.text('review_by',{name}));
        const meta = document.createElement('div');
        meta.className = 'ts-category-reviews__meta';
        const stars = document.createElement('span');
        stars.className = 'ts-category-reviews__item-stars';
        stars.setAttribute('role','img');
        stars.setAttribute('aria-label',this.text('stars',{rating}));
        for (let i=1;i<=5;i++) {
          const star=document.createElement('span');
          star.textContent='★';
          star.setAttribute('aria-hidden','true');
          if(i>rating) star.className='ts-category-reviews__empty-star';
          stars.append(star);
        }
        const author=document.createElement('strong');
        author.textContent=name;
        meta.append(stars,author);
        const date=new Date(review.date);
        if(!Number.isNaN(date.getTime())) {
          const time=document.createElement('time');
          time.dateTime=date.toISOString().slice(0,10);
          time.textContent=new Intl.DateTimeFormat(this.dataset.locale || 'de',{day:'2-digit',month:'2-digit',year:'numeric',timeZone:'UTC'}).format(date);
          meta.append(time);
        }
        article.append(meta);
        if(review.body) {
          const text=document.createElement('p');
          text.id=this.dialog.id+'-text-'+index;
          text.className='ts-category-reviews__text';
          text.textContent=String(review.body);
          text.dataset.collapsed='true';
          const expand=document.createElement('button');
          expand.type='button';
          expand.className='ts-category-reviews__expand';
          expand.textContent=this.text('read_more');
          expand.setAttribute('aria-controls',text.id);
          expand.setAttribute('aria-expanded','false');
          expand.hidden=true;
          expand.addEventListener('click',()=>{
            const opened=expand.getAttribute('aria-expanded')!=='true';
            expand.setAttribute('aria-expanded',String(opened));
            text.dataset.collapsed=String(!opened);
            expand.textContent=this.text(opened?'read_less':'read_more');
          });
          article.append(text,expand);
        }
        this.list.append(article);
      }
      this.sort.value=this.order;
      this.querySelector('.ts-category-reviews__source').textContent=this.text(this.source==='api'?'all_reviews':'selection');
      if(!reviews.length) this.list.textContent=this.text('empty');
      this.updateControls();
      requestAnimationFrame(()=>this.updateExpansion());
    }
    updateExpansion() {
      this.list.querySelectorAll('.ts-category-reviews__text[data-collapsed="true"]').forEach(text=>{
        text.nextElementSibling.hidden=text.scrollHeight<=text.clientHeight+1;
      });
    }
    updateControls() {
      const pages=Math.max(1,Math.ceil(this.total/this.pageSize));
      this.previous.disabled=this.busy || this.page<=1;
      this.next.disabled=this.busy || this.page>=pages;
      this.sort.disabled=this.busy;
      this.retry.disabled=this.busy;
      this.querySelector('.ts-category-reviews__page').textContent=this.text('page',{page:this.page,pages});
      this.querySelector('.ts-category-reviews__progress').textContent=this.text('range',{start:this.total?(this.page-1)*this.pageSize+1:0,end:Math.min(this.page*this.pageSize,this.total),total:this.total});
    }
    finishNavigation(moveFocus) {
      this.body.scrollTop=0;
      if(moveFocus && this.dialog.open) this.body.focus({preventScroll:true});
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle.shoppact-intro"] && !Shopify.designMode) return;
  try {
    (() => {
  const mobile = window.matchMedia('(max-width: 650px)');
  function initialize() {
    document.querySelectorAll('.tf-compact-intro-enabled [data-tf-intro-more]').forEach(details => {
      if (details.hasAttribute('data-tf-ready')) return;
      details.open = !mobile.matches;
      details.setAttribute('data-tf-ready', '');
    });
  }
  mobile.addEventListener('change', () => {
    document.querySelectorAll('.tf-compact-intro-enabled [data-tf-intro-more]').forEach(details => { details.open = !mobile.matches; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-daith-master-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>{document.querySelectorAll('[data-tf-daith-master-guide]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const media=window.matchMedia('(min-width:651px)');const update=()=>{root.classList.toggle('dp-desktop',media.matches);};update();media.addEventListener('change',update)})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();document.addEventListener('shopify:section:load',initialize)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-dehnstaebe-master-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>{document.querySelectorAll('[data-tf-dehnstaebe-master-guide]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('.dp-topic-more,.dp-faq details,.tfcc-panel').forEach(details=>{details.open=false})})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();document.addEventListener('shopify:section:load',initialize)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-desktop-menu"] && !Shopify.designMode) return;
  try {
    // Keep the current panel visible while the pointer crosses the spacing between
// top-level links. Entering another link switches immediately, without an open delay.
(() => {
  const canHover = window.matchMedia('(min-width: 1001px) and (hover: hover) and (pointer: fine)');
  const prepareMenuImages = () => {
    if (!canHover.matches || document.documentElement.classList.contains('m2a')) return;
    document.querySelectorAll('.shopify-section-header #nav > ul[data-type="main-nav"], .shopify-section-header #nav-bar > ul[data-type="horizontal-nav"]').forEach(nav => {
      nav.querySelectorAll(':scope > .ts-desktop-dropdown > .ts-desktop-panel > li > ul > li > .ts-desktop-link img[loading="lazy"]').forEach(image => {
        image.setAttribute('fetchpriority', 'low');
        image.loading = 'eager';
      });
    });
  };
  canHover.addEventListener('change', prepareMenuImages);
  const setupHoverBridge = () => {
    prepareMenuImages();
    document.querySelectorAll('.shopify-section-header #nav > ul[data-type="main-nav"], .shopify-section-header #nav-bar > ul[data-type="horizontal-nav"]').forEach(nav => {
      if (nav.dataset.tsHoverBridgeReady) return;
      nav.dataset.tsHoverBridgeReady = 'true';
      const items = Array.from(nav.children);
      let heldItem = null;
      let closeTimer;
      const release = () => {
        window.clearTimeout(closeTimer);
        if (heldItem) heldItem.classList.remove('ts-hover-bridge');
        heldItem = null;
      };
      items.forEach(item => {
        item.addEventListener('pointerenter', event => {
          if (!canHover.matches || event.pointerType === 'touch' || document.documentElement.classList.contains('m2a')) return;
          release();
          items.forEach(other => {
            if (other === item) return;
            const details = other.querySelector(':scope > .ts-further-menu__details');
            if (details && !details.contains(document.activeElement)) details.open = false;
          });
          if (item.querySelector(':scope > .ts-desktop-panel')) {
            heldItem = item;
            item.classList.add('ts-hover-bridge');
          }
        });
        item.addEventListener('pointerleave', event => {
          if (heldItem !== item || event.pointerType === 'touch') return;
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(release, 200);
        });
      });
      nav.addEventListener('focusin', release);
      nav.addEventListener('keydown', event => { if (event.key === 'Escape') release(); });
      document.addEventListener('pointerdown', event => { if (!nav.contains(event.target)) release(); });
      canHover.addEventListener('change', release);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupHoverBridge);
  else setupHoverBridge();
  document.addEventListener('shopify:section:load', setupHoverBridge);
})();

(() => {
  const desktop = window.matchMedia('(min-width: 1001px)');
  const setup = () => {
    document.querySelectorAll('.ts-desktop-dropdown').forEach(item => {
      if (item.dataset.tsReady) return;
      const panel = item.querySelector(':scope > .ts-desktop-panel');
      if (!panel) return;
      item.dataset.tsReady = 'true';
      const count = Number(panel.dataset.tsMenuCount);
      const columns = count >= 8 ? 3 : 1;
      panel.style.setProperty('--ts-columns', columns);
      panel.style.setProperty('--ts-rows', Math.ceil(count / columns));
      const position = () => {
        if (!desktop.matches || !panel.getClientRects().length) return;
        const rect = item.getBoundingClientRect();
        const panelWidth = panel.offsetWidth;
        const viewportWidth = document.documentElement.clientWidth;
        const desired = Math.max(16, Math.min(rect.left, viewportWidth - panelWidth - 16));
        const left = (desired - rect.left) + 'px';
        if (panel.style.getPropertyValue('--ts-panel-left') !== left) panel.style.setProperty('--ts-panel-left', left);
      };
      item.addEventListener('mouseenter', position);
      item.addEventListener('focusin', position);
      item.addEventListener('click', () => requestAnimationFrame(position));
      window.addEventListener('resize', position);
      if (document.fonts) {
        document.fonts.ready.then(position);
        document.fonts.addEventListener('loadingdone', position);
      }
      panel.querySelectorAll('.ts-desktop-flyout').forEach(flyout => {
        const parent = flyout.parentElement;
        const placeFlyout = () => {
          if (!desktop.matches || !flyout.getClientRects().length) return;
          const bounds = parent.getBoundingClientRect();
          const leftward = bounds.right + flyout.offsetWidth + 8 > document.documentElement.clientWidth - 16;
          flyout.toggleAttribute('data-ts-left', leftward);
          flyout.style.setProperty('--ts-flyout-left', leftward ? (-flyout.offsetWidth - 8) + 'px' : (bounds.width + 8) + 'px');
          const top = Math.max(8 - bounds.top, Math.min(-10, window.innerHeight - flyout.offsetHeight - 20 - bounds.top));
          flyout.style.setProperty('--ts-flyout-top', top + 'px');
        };
        parent.addEventListener('mouseenter', placeFlyout);
        parent.addEventListener('focusin', placeFlyout);
        parent.addEventListener('click', () => requestAnimationFrame(placeFlyout));
        window.addEventListener('resize', placeFlyout);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();

(() => {
  const setupFurtherMenus = () => {
    document.querySelectorAll('.ts-further-menu__details').forEach(details => {
      if (details.dataset.furtherReady) return;
      details.dataset.furtherReady = 'true';
      const canHover = window.matchMedia('(min-width: 1001px) and (hover: hover) and (pointer: fine)');
      let closeTimer;
      const cancelClose = () => window.clearTimeout(closeTimer);
      details.addEventListener('pointerenter', event => {
        cancelClose();
        if (canHover.matches && event.pointerType !== 'touch') details.open = true;
      });
      details.addEventListener('pointerleave', event => {
        if (!canHover.matches || event.pointerType === 'touch') return;
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (!details.contains(document.activeElement)) details.open = false;
        }, 140);
      });
      details.addEventListener('focusin', cancelClose);
      details.addEventListener('focusout', () => {
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (!details.contains(document.activeElement) && !details.matches(':hover')) details.open = false;
        }, 0);
      });

      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); }
      });
      document.addEventListener('click', event => { if (!details.contains(event.target)) details.open = false; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupFurtherMenus);
  else setupFurtherMenus();
  document.addEventListener('shopify:section:load', setupFurtherMenus);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-flesh-master-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>{document.querySelectorAll('[data-tf-flesh-master-guide]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('.dp-topic-more,.dp-faq details,.tfcc-panel').forEach(details=>{details.open=false})})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();document.addEventListener('shopify:section:load',initialize)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-footer-discover"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var trigger = event.target.closest('[data-tff-discover-toggle]');
    if (!trigger) return;
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    var expanded = trigger.getAttribute('aria-expanded') !== 'true';
    trigger.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
    if (!expanded) panel.querySelectorAll('details[open]').forEach(function (group) { group.open = false; });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-guertel-master-guide"] && !Shopify.designMode) return;
  try {
    window.addEventListener('pageshow', () => {
  document.querySelectorAll('#root .tf-guertel-master-guide details[open]').forEach(panel => { panel.open = false; });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-helix-gold-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize() {
    document.querySelectorAll('[data-tf-helix-gold-master-guide]').forEach(root => {
      if (root.dataset.tfHelixGoldMasterReady) return;
      root.dataset.tfHelixGoldMasterReady = 'true';
      root.querySelectorAll('.dp-topic-more').forEach(details => { details.open = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-helix-master-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>{document.querySelectorAll('[data-tf-helix-master-guide]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const media=window.matchMedia('(min-width:651px)');const update=()=>{root.classList.toggle('dp-desktop',media.matches);};update();media.addEventListener('change',update)})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();document.addEventListener('shopify:section:load',initialize)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-helix-silber-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize() {
    document.querySelectorAll('[data-tf-helix-silber-master-guide]').forEach(root => {
      if (root.dataset.tfHelixSilberMasterReady) return;
      root.dataset.tfHelixSilberMasterReady = 'true';
      root.querySelectorAll('.dp-topic-more').forEach(details => { details.open = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-intim-frauen-master-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>{document.querySelectorAll('[data-tf-intim-frauen-master-guide]').forEach(root=>{if(root.dataset.faqPackage4Ready)return;root.dataset.faqPackage4Ready='true';root.querySelectorAll('details').forEach(d=>d.open=false)})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();document.addEventListener('shopify:section:load',initialize);window.addEventListener('pageshow',()=>document.querySelectorAll('[data-tf-intim-frauen-master-guide] details').forEach(d=>d.open=false))})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-intim-maenner-master-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>{document.querySelectorAll('[data-tf-intim-maenner-master-guide]').forEach(root=>{if(root.dataset.faqPackage4Ready)return;root.dataset.faqPackage4Ready='true';root.querySelectorAll('details').forEach(d=>d.open=false)})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();document.addEventListener('shopify:section:load',initialize);window.addEventListener('pageshow',()=>document.querySelectorAll('[data-tf-intim-maenner-master-guide] details').forEach(d=>d.open=false))})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-intim-master-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>{document.querySelectorAll('[data-tf-intim-master-guide]').forEach(root=>{if(root.dataset.faqPackage4Ready)return;root.dataset.faqPackage4Ready='true';root.querySelectorAll('details').forEach(d=>d.open=false)})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();document.addEventListener('shopify:section:load',initialize);window.addEventListener('pageshow',()=>document.querySelectorAll('[data-tf-intim-master-guide] details').forEach(d=>d.open=false))})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-legal-guarantee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('taffstyle-cart-guarantee')) {
    customElements.define('taffstyle-cart-guarantee', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.trigger = this.querySelector('.tscg-trigger');
        this.dialog = this.querySelector('dialog');
        if (!this.trigger || !this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.trigger.addEventListener('click', event => {
          event.preventDefault();
          if (!this.dialog.open) this.dialog.showModal();
          this.dialog.scrollTop = 0;
          this.trigger.setAttribute('aria-expanded', 'true');
        }, options);
        this.querySelectorAll('[data-tscg-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'Escape') event.stopPropagation();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.focus({ preventScroll:true });
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-nasen-master-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>{document.querySelectorAll('[data-tf-nasen-master-guide]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('details').forEach(d=>d.open=false)})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();document.addEventListener('shopify:section:load',initialize)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-nasen-rosegold-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize() {
    document.querySelectorAll('[data-tf-nasen-rosegold-master-guide]').forEach(root => {
      if (root.dataset.tfNasenRosegoldMasterReady) return;
      root.dataset.tfNasenRosegoldMasterReady = 'true';
      root.querySelectorAll('.dp-topic-more').forEach(details => { details.open = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-prinz-albert-master-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>{document.querySelectorAll('[data-tf-prinz-albert-master-guide]').forEach(root=>{if(root.dataset.faqPackage4Ready)return;root.dataset.faqPackage4Ready='true';root.querySelectorAll('details').forEach(d=>d.open=false)})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();document.addEventListener('shopify:section:load',initialize);window.addEventListener('pageshow',()=>document.querySelectorAll('[data-tf-prinz-albert-master-guide] details').forEach(d=>d.open=false))})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-skin-diver-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize() {
    document.querySelectorAll('[data-tf-skin-diver-master-guide]').forEach(root => {
      if (root.dataset.tfSkinDiverMasterReady) return;
      root.dataset.tfSkinDiverMasterReady = 'true';
      root.querySelectorAll('details').forEach(details => { details.open = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-tragus-gold-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize() {
    document.querySelectorAll('[data-tf-tragus-gold-master-guide]').forEach(root => {
      if (root.dataset.tfTragusGoldMasterReady) return;
      root.dataset.tfTragusGoldMasterReady = 'true';
      root.querySelectorAll('.dp-topic-more').forEach(details => { details.open = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-tragus-master-guide"] && !Shopify.designMode) return;
  try {
    (()=>{const initialize=()=>{document.querySelectorAll('[data-tf-tragus-master-guide]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const media=window.matchMedia('(min-width:651px)');const update=()=>{root.classList.toggle('dp-desktop',media.matches);};update();media.addEventListener('change',update)})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();document.addEventListener('shopify:section:load',initialize)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-tragus-silber-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize() {
    document.querySelectorAll('[data-tf-tragus-silber-master-guide]').forEach(root => {
      if (root.dataset.tfTragusSilberMasterReady) return;
      root.dataset.tfTragusSilberMasterReady = 'true';
      root.querySelectorAll('.dp-topic-more').forEach(details => { details.open = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taffstyle-trio-guide"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.querySelectorAll('[data-tf-trio]').forEach(root => {
      if (root.dataset.tfTrioReady) return;
      root.dataset.tfTrioReady = 'true';
      root.querySelectorAll('details').forEach(details => { details.open = false; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-tf-trio] details').forEach(details => { details.open = false; });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
